import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IBlankslate } from 'codex-lib';
import { Observer } from '../../../model/observer';
import { CheckboxState } from 'src/app/enum/checkbox-state';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-observer-table',
  templateUrl: './observer-table.component.html',
  styleUrls: ['./observer-table.component.scss'],
})
export class ObserverTableComponent implements OnInit {
  @Output() checkAllClick = new EventEmitter();
  @Output() elementClick = new EventEmitter();
  @Output() cleanSearchClick = new EventEmitter();

  @Input() elements: Array<Observer>;
  @Input() headerCheckboxState: CheckboxState;
  blankslateOptions: IBlankslate;
  checkboxState = CheckboxState;
  hiddenPhoneColumn: boolean;

  constructor(private authService: AuthService) {
    if (!this.authService.signUserModel) {
      return;
    }

    this.hiddenPhoneColumn = !this.authService.signUserModel.sendWhatsapp;
  }

  ngOnInit() {
    this.blankslateOptions = {
      icon: {
        prefix: 'fad',
        iconName: 'search-minus',
      },
      buttonText: 'cleanSearch',
    };
  }

  onHeaderCheckboxChange() {
    this.checkAllClick.emit();
  }

  onCheckboxClick(el) {
    this.elementClick.emit(el);
  }

  onBlankSlateButtonClick() {
    this.cleanSearchClick.emit();
  }
}
